import { render } from "./monitorRoom.vue?vue&type=template&id=16c4283c&scoped=true"
import script from "./monitorRoom.vue?vue&type=script&lang=js"
export * from "./monitorRoom.vue?vue&type=script&lang=js"

import "./monitorRoom.vue?vue&type=style&index=0&id=16c4283c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c4283c"]])

export default __exports__